import React from 'react';
import { useOutletContext } from "react-router-dom";

import Banner1 from './Banner1';
import Content0 from './Content0';
// import Content1 from './Content1';
import Content3 from './Content3';
import Feature4 from  '../about/Feature4';
import { Content50DataSource, Feature40DataSource, Feature60DataSource } from '../about/data.source';
import {
  Banner10DataSource,
  Content00DataSource,
  // Content10DataSource,
  Content30DataSource,
} from './data.source';
import './less/index.less';
import Content5 from '../about/Content5';
export default function Home() {

  const { isMobile } = useOutletContext();

  const children = [
    <Banner1
      id="Banner1_0"
      key="Banner1_0"
      dataSource={Banner10DataSource}
      isMobile={isMobile}
    />,
    <Feature4
      id="Feature4_0"
      key="Feature4_0"
      dataSource={Feature40DataSource}
      isMobile={isMobile}
    />,
    <Content0
      id="Content0_0"
      key="Content0_0"
      dataSource={Content00DataSource}
      isMobile={isMobile}
    />,
    // <Content1
    //   id="Content1_0"
    //   key="Content1_0"
    //   dataSource={Content10DataSource}
    //   isMobile={isMobile}
    // />,

    <Content3
      id="Content3_0"
      key="Content3_0"
      dataSource={Content30DataSource}
      isMobile={isMobile}
    />,
    <Content5
      id="Content5_0"
      key="Content5_0"
      dataSource={Content50DataSource}
      contentDataSource={Feature60DataSource}
      isMobile={isMobile}
    />,
  ];
  return (
    <div
      className="templates-wrapper"
    >
      {children}
    </div>
  );
}
